import { getScript, type Script } from '@/api/studio-production'
import { getWriterScript } from '@/api/studio-writer'

export function invalidateProductionScriptEpisodes(_productionId: string, _scriptId?: number) {
  /* 分集每次直拉，无进程缓存 */
}

export function invalidateWriterScriptEpisodes(_scriptId?: number) {
  /* 分集每次直拉，无进程缓存 */
}

export function patchProductionScriptEpisodeCache(
  _productionId: string,
  _scriptId: number,
  _episodeNo: number,
  _patch: Partial<Script>,
  _locale?: string,
) {
  /* 分集每次直拉，无进程缓存 */
}

export function patchWriterScriptEpisodeCache(
  _scriptId: number,
  _episodeNo: number,
  _patch: Partial<Script>,
  _locale?: string,
) {
  /* 分集每次直拉，无进程缓存 */
}

/** 制片项目 · 分集正文（每次直拉） */
export function fetchProductionScriptEpisode(
  productionId: string,
  scriptId: number,
  episodeNo: number,
  locale?: string,
): Promise<Script> {
  return getScript(productionId, scriptId, episodeNo, locale)
}

/** 编剧工作台 · 分集正文（每次直拉） */
export function fetchWriterScriptEpisode(
  scriptId: number,
  episodeNo: number,
  locale?: string,
): Promise<Script> {
  return getWriterScript(scriptId, episodeNo, locale)
}
